import React, { Component } from 'react';

// import icon1 from '../../assets/img/certificate/certi1.JPG';
// import icon2 from '../../assets/img/certificate/certi2.JPG';
import icon3 from '../../assets/img/certificate/certi3.JPG';

const iconsblock = [
    { icon: icon3, title: 'Certificate 1' },
    { icon: icon3, title: 'Certificate 2' },
    { icon: icon3, title: 'Certificate 3' },
];

class Icons extends Component {
    render() {
        return (
            <div className="row">
                {iconsblock.map((item, i) => (
                    <div className="col-xl-4 col-lg-4 col-sm-6" key={i}>
                        <div className="sigma_icon-block icon-block-5">
                            <div className="icon-wrapper">
                                <img src={item.icon} alt="" style={{width: "100%"}}/>
                            </div>
                            <div className="sigma_icon-block-content">
                                <h5>{item.title}</h5>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default Icons;